const statsToSummary = (stat) => Object.entries(stat).map(([label, value]) => ({ label, id: label, value }));

export default statsToSummary;
